<template>
  <div
    v-if="showBanner"
    class="license-banner-bar"
    role="region"
    aria-label="Subscription status"
  >
    <div class="license-banner-inner">
      <span v-if="isTrial && daysLeftInLicense > 0" class="lb-message">
        <span class="lb-count">{{ daysLeftInLicense }}</span> days remaining
      </span>
      <span v-else-if="isIndividual && isPremium && isLicenseExpired" class="lb-message">
        Subscription ended
      </span>
      <span v-else-if="isEnterpriseEndingSoon" class="lb-message">
        <span class="lb-count">{{ daysLeftInLicense }}</span> days remaining —
        {{
          isMultiyear
            ? "Your license will be updated when your organization's multiyear renewal process is complete."
            : 'Please contact your administrator to renew your district membership.'
        }}
      </span>
      <span class="lb-actions">
        <a
          v-if="(isTrial && !universityPartnership) || (isIndividual && isPremium)"
          :href="subscribe"
        >View Plans</a
        >
        <a
          v-if="isTrial && universityPartnership"
          :href="subscribeUniversity"
        >University Membership</a
        >
        <a class="share" :href="share">Share Toolkit</a>
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { toolkitUrls } from '@/links'

export default {
  name: 'LicenseBanner',
  data() {
    return { ...toolkitUrls }
  },
  computed: {
    ...mapGetters('user', [
      'hasLicense',
      'isSuperAdmin',
      'isTrial',
      'isPremium',
      'isEnterprise',
      'isIndividual',
      'isMultiyear',
      'daysLeftInLicense',
      'isLicenseExpired',
      'isEnterpriseEndingSoon',
    ]),
    ...mapState('user', {
      universityPartnership: (state) => state.domain_upp,
    }),
    showBanner() {
      return (
        this.hasLicense &&
        !this.isSuperAdmin &&
        (!this.isEnterprise ||
          !this.isPremium ||
          this.isEnterpriseEndingSoon ||
          this.isLicenseExpired)
      )
    },
  },
}
</script>

<style scoped lang="less">
@import '~@/variables.less';

.license-banner-bar {
  width: 100%;
  background: @gb_orange;
  color: @gray-dark;
  font-size: 14px;
  line-height: 1.4;
  margin-top: -20px;
  margin-bottom: 20px;
}

.license-banner-inner {
  width: 100%;
  box-sizing: border-box;
  max-width: 1170px;
  margin: 0 auto;
  padding: 8px 16px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 2px 16px;
  text-align: center;
}

.lb-message {
  margin: 0;
  line-height: 1.4;
}

.lb-count {
  font-weight: 700;
}

.lb-actions {
  display: inline;
  line-height: 1.4;
}

.lb-actions a + a {
  margin-left: 16px;
}

a,
a:link,
a:visited,
a:active {
  color: @gray-dark;
  font-weight: 600;
  text-decoration: underline;
}

a:hover {
  color: @gray-dark;
}

a:focus-visible {
  outline: 2px solid @gray-dark;
  outline-offset: 2px;
}
</style>
